import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { round } from 'lodash'
import { P152_1 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity } from 'rpqs/utils/RPQSUtils'

const DialogP152_1 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        rpqs,
        managementEntity,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntity] = useState(managementEntity)

    useEffect(() => {
        setEntity(managementEntity)
    }, [managementEntity])

    const year = rpqs.year
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const rows = [
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            keyLabel: 'nbConnectionsOpenedOnTime',
            indicatorName: i18n.nbConnectionsOpenedOnTime,
            unit: i18n.writtenComplaints,
            onChange: v => setEntity(prev => (updateIndicatorEntity(prev, year, 'nbConnectionsOpenedOnTime',
                { ...currentEntity?.nbConnectionsOpenedOnTime, value: parseInt(v) || 0 },
            ))),
        }),

        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            keyLabel: 'nbConnectionsOpened',
            indicatorName: i18n.nbConnectionsOpened,
            unit: i18n.writtenComplaints,
            onChange: v => setEntity(prev => (updateIndicatorEntity(prev, year, 'nbConnectionsOpened',
                { ...currentEntity?.nbConnectionsOpened, value: parseInt(v) || 0 },
            ))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntity(updateIndicatorEntity(entityDialog, year, P152_1.code, { ...currentEntity?.[P152_1.code], status }))
    }

    const getIndicatorValue = (indi) => (currentEntity?.[indi]?.value || 0)

    const calculation = () => {
        const calculatedValue = getIndicatorValue('nbConnectionsOpened') != 0 ? round(getIndicatorValue('nbConnectionsOpenedOnTime') / getIndicatorValue('nbConnectionsOpened') * 100, 2) : 0

        return updateIndicatorEntity(entityDialog, year, P152_1.code, { ...currentEntity?.[P152_1.code], value: calculatedValue })
    }

    const currentValue = managementEntity?.[year]?.[P152_1.code]?.value ? `${managementEntity?.[year]?.[P152_1.code]?.value} %` : '/'
    const previousValue = managementEntity?.[previousYear]?.[P152_1.code]?.value ? `${managementEntity?.[previousYear]?.[P152_1.code]?.value} %` : '/'

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntity}
            codeIndicator={P152_1.code}
            calculationOnRegister={calculation}
        >
            {year && previousYear &&
                <Grid container direction={'column'} gap={2} size={12}>
                    <IndicatorHeaderDialog
                        current={{
                            year,
                            value: currentValue,
                        }}
                        previous={{
                            year: previousYear,
                            value: previousValue,
                        }}
                        status={entityDialog?.[year]?.[P152_1.code]?.status}
                        onStatusChange={onStatusChange}
                    />
                    <Divider/>
                    <IndicatorTable
                        year={year.toString()}
                        indicators={rows}
                    />

                </Grid>
            }
        </EntityIndicatorDialog>
    )
}

DialogP152_1.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP152_1
